<!-- Fixed Background Image - iOS keyboard fix -->
<div class="fixed-bg">
  <img src="/assets/images/RMResidentPortal.jpg" alt="" />
</div>

<!-- Header -->
<div class="resident-header">
  <div class="resident-header-title">
    <span>RESIDENT</span>
    <span>PORTAL</span>
  </div>
</div>

<!-- Inactivity Logout Message -->
<div
  class="inactivity-logout-banner"
  *ngIf="showInactivityLogoutMessage"
  (click)="dismissInactivityMessage()"
>
  <div class="banner-content">
    <i class="fa-solid fa-circle-check"></i>
    <span>
      You have been signed out due to inactivity and security reasons. Please
      sign in again.
    </span>
  </div>
</div>
<div class="page-content">
  <div class="login-panel-container">
    <div class="dual-card-container">
      <!-- Left Column: Login Panel -->
      <div class="left-column">
        <!-- Login Card -->
        <div class="auth-card login-card">
          <div class="login-container">
            <dx-responsive-box width="100%" height="100%">
              <dxi-row></dxi-row>
              <dxi-item>
                <dxi-location [row]="1" [col]="0"></dxi-location>
                <div *dxTemplate class="cc-login-portal-header">
                  <div class="login-portal-wrapper">
                    <div class="login-portal-wrapper-row">
                      <div
                        *ngIf="!isRMLogoHidden"
                        class="login-portal-wrapper-logo"
                      >
                        <app-icon name="logo" size="100%"></app-icon>
                      </div>
                    </div>
                    <div
                      [ngClass]="{
                        'login-portal-header': !isSmallScreen,
                        'login-portal-header-small': isSmallScreen
                      }"
                      [innerHTML]="loginHeaderText"
                    ></div>
                  </div>
                </div>
              </dxi-item>
            </dx-responsive-box>
            <div>
              <router-outlet></router-outlet>
            </div>
          </div>
          <app-welcome-message></app-welcome-message>
        </div>

        <!-- Quick Pay Panel -->
        <div
          class="auth-card quick-pay-card"
          [class.expanded]="isQuickPayExpanded"
        >
          <!-- Collapsed State -->
          <div class="quick-pay-collapsed" *ngIf="!isQuickPayExpanded">
            <div class="quick-pay-icon">
              <app-icon
                name="quick-pay-logo"
                size="40px"
                ariaLabel="Quick Pay Icon"
              ></app-icon>
            </div>
            <h3 class="quick-pay-title">Quick Pay</h3>
            <p class="quick-pay-description">
              Want to pay your bill online? Simply enter your 16-digit account
              number or sign in with your credentials.
            </p>
            <a href="#" class="quick-pay-link" (click)="toggleQuickPay($event)">
              Make quick payment
            </a>
          </div>

          <!-- Expanded State -->
          <div class="quick-pay-expanded" *ngIf="isQuickPayExpanded">
            <app-quick-payment [isEmbedded]="true"></app-quick-payment>
          </div>
        </div>
      </div>

      <!-- Right Column: Real Assist -->
      <div class="right-column">
        <div class="real-assist-container">
          <app-real-assist
            [variant]="isSmallScreen ? 'chat' : 'widget'"
          ></app-real-assist>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="support-bar">
  <div class="support-section">
    <!-- Our Company Section -->
    <div class="company-section">
      <h4>Our Company</h4>
      <div class="company-links">
        <a
          [href]="aboutCiraNetUrl"
          class="external-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          About CiraNet
          <app-icon name="external-link" size="12px"></app-icon>
        </a>
        <a
          [href]="privacyPolicyUrl"
          class="external-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
          <app-icon name="external-link" size="12px"></app-icon>
        </a>
        <a
          [href]="termsAndConditionsUrl"
          class="external-link terms-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms and Conditions
          <app-icon name="external-link" size="12px"></app-icon>
        </a>
      </div>
    </div>

    <!-- Contact Row: Customer Support and Board Member -->
    <div class="contact-row">
      <div class="support-column">
        <h4>Customer Support</h4>
        <p>
          Email:
          <a href="mailto:service@ciramail.com">service&#64;ciramail.com</a>
        </p>
      </div>

      <div class="support-column">
        <h4>Board Member</h4>
        <p>
          Management Portal:
          <a
            href="https://management.ciranet.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            management.ciranet.com
          </a>
        </p>
      </div>
    </div>
  </div>
</div>
<footer class="footer-bar">
  <div>
    <app-icon
      name="footer-logo"
      width="193px"
      height="40px"
      ariaLabel="footer logo"
    ></app-icon>
  </div>
</footer>
